import { BreadcrumbList } from '@greystar/designsystem';
import { Link, useAnalytics } from '@greystar/lib';
import { EventProperty } from '@greystar/lib/src/types/property-types';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { BreadcrumbProps } from '../../../component-props';

interface PathType {
  label: string;
  url: string;
  onClick?: () => void;
}

const BreadcrumbNavigation = (props: BreadcrumbProps): JSX.Element => {
  const analytics = useAnalytics();
  const { sitecoreContext } = useSitecoreContext();
  const property: EventProperty = sitecoreContext?.property ?? {};

  const handleBreadcrumbClick = (url: string, label: string, links: PathType[]) => {
    const location = property?.location ?? {};
    const addressParts = [
      location?.address ?? '',
      location?.city ?? '',
      location?.state ?? '',
      location?.postalCode ?? '',
    ].filter(Boolean);
    const property_location = addressParts.join(', ') ?? '';
    const breadcrumbTrail = links.map((link) => link.label).join(' > ');

    const eventData = {
      event: 'breadcrumbs',
      action_type: `back to ${label}`,
      state: location?.state ?? '',
      property_location,
      property_id: property.id ?? '',
      property_name: property.name ?? '',
      module_name: 'breadcrumb navigation',
      inpage_location: 'top',
      click_text: breadcrumbTrail,
      click_type: 'internal',
      destination_url: url,
    };

    analytics.trackEvent('breadcrumbs', eventData);
  };

  const transformProps = (links: Link[]): PathType[] => {
    const transformedLinks: PathType[] = [];

    links.forEach((link) => {
      transformedLinks.push({
        label: link.text,
        url: link.href,
        onClick: () => handleBreadcrumbClick(link.href, link.text, transformedLinks),
      });
    });

    return transformedLinks;
  };

  const data = transformProps(props.links);

  return <BreadcrumbList breadcrumb={data} />;
};

export default BreadcrumbNavigation;
